class RewardGroupService {
  constructor(client) {
    this.apiClient = client;
  }

  async getRewardGroups(entityID, { limit = 10, offset = 0, sort = "name_asc" } = {}) {
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups?limit=${limit}&offset=${offset}&sort=${sort}`
    );
  }

  async getRewardGroup(entityID, rewardGroupID) {
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups/${rewardGroupID}`
    );
  }

  async createRewardGroup(entityID, rewardGroup) {
    return await this.apiClient.post(
      `onepark/${entityID}/reward-groups`,
      rewardGroup
    );
  }

  async updateRewardGroup(entityID, rewardGroupID, rewardGroup) {
    return await this.apiClient.put(
      `onepark/${entityID}/reward-groups/${rewardGroupID}`,
      rewardGroup
    );
  }

  async deleteRewardGroup(entityID, rewardGroupID) {
    return await this.apiClient.delete(
      `onepark/${entityID}/reward-groups/${rewardGroupID}`
    );
  }

  async getEligibleAccessGroups(entityID) {
    return await this.apiClient.get(
      `onepark/${entityID}/reward-groups/eligible-access-groups`
    );
  }
}

export default RewardGroupService;
